"use strict";
(self["webpackChunk_N_E"] = self["webpackChunk_N_E"] || []).push([[2463],{

/***/ 30842:
/***/ (function(__unused_webpack_module, __webpack_exports__) {

/* harmony default export */ __webpack_exports__["Z"] = ({"src":"/_next/static/media/use-ferro.f745bb8e.png","height":120,"width":120,"blurDataURL":"data:image/png;base64,iVBORw0KGgoAAAANSUhEUgAAAAgAAAAICAYAAADED76LAAAA60lEQVR42j3JPUsCAQCH8UdFLehFyNB8Oe/q4oyu6V64aOkIaxKCagtsCtqirYaosQ/R1J6u9QlqrqnZ2VE4C//dED3wmx6iuEPKbNnOC5AA38A74PGX0baMob/ZFiCnuqRmy1Jgm+PTeDsEGFjzOXm1UpIBuUZTQbQ32SmjInywOFscrVXKKoHMEgK0Aep1L6a7fkdQbows25Ub7Kt+cq3o7F6124Gqj1/T1tGVIDzs5w/ONdd7SLh80szNs+p3/UnlOJ3wScHvGjTcIcurymYQ/BsX1oOQLJCygFeyuYSFlZ9MzXnLb8UewC9870v0JjIXKwAAAABJRU5ErkJggg==","blurWidth":8,"blurHeight":8});

/***/ }),

/***/ 34061:
/***/ (function(__unused_webpack_module, __webpack_exports__) {

/* harmony default export */ __webpack_exports__["Z"] = ({"src":"/_next/static/media/use-tectonic.5504b7fd.png","height":120,"width":120,"blurDataURL":"data:image/png;base64,iVBORw0KGgoAAAANSUhEUgAAAAgAAAAICAYAAADED76LAAABCklEQVR4nA2OMUvDQBxHf/+7y9kKjUQRSwqholsdCg5KbUkGJx0UXMRRcFB3wY9SJz9AQQd3B0GXZpEM0sFBnbTWaANJk17OPHjbGx6tVlswoetfSnUB8hjAGSM/VflZpVT26bp97PTD4dNd+GNbnGGqNVQOCGLx0oz0qFFr33JGe4KLlAiSgcA5z1KljXiqAnJtdxQzWKbg0ASwokJhpKDLVHCyvjsahhNrQXLMVwSomIig8f6rdJZoosvtg5voc7wvJixtuXPStCSCtyR7fvkzjDQPaGut6VTi0uN4dqW22UhwtLOI+36CXi+MO9VXj2A4ANSyrHe6p03bPdwQ7GHw4V9cfZ8DA/8fLFZf9MLFWbcAAAAASUVORK5CYII=","blurWidth":8,"blurHeight":8});

/***/ }),

/***/ 33267:
/***/ (function(__unused_webpack_module, __webpack_exports__) {

/* harmony default export */ __webpack_exports__["Z"] = ({"src":"/_next/static/media/use-vvs.88bd7163.png","height":128,"width":128,"blurDataURL":"data:image/png;base64,iVBORw0KGgoAAAANSUhEUgAAAAgAAAAICAYAAADED76LAAABE0lEQVR4nAEIAff+Aby/xgAwMi4prqyvmNrZ3Tn9/QAAKCYeyFZVT2fQ0tbXAefr8CmTkZbFhoSaEQAACQApAPkA1wAuAHV/Qe90bV07AZ6gpsGioKw+XlQP+kc/DwbGxOcA8xA5+v/u4Qb2/SrCAaKlqPrn5uQFQjf9ABcQ8QD9+v0ACwP1AM23FAC77Q37AZibnvr48+4FAgIIAOXo+gBUR+cALhgMAKGhLwDkCA/7AaaprMHU0dA+IxL5+v718gYcLB0ADCJR+vro1gYiExTCAePn7CmjoqbF1MzNEQQC/ADP3/8A0/4iAKloFO9WY007Abm8wwArLCkprayymN3d4DkDAP0AJiUbxzBDVmglBcrXlZJ7iLJmEcAAAAAASUVORK5CYII=","blurWidth":8,"blurHeight":8});

/***/ }),

/***/ 28521:
/***/ (function(__unused_webpack_module, __webpack_exports__, __webpack_require__) {


// EXPORTS
__webpack_require__.d(__webpack_exports__, {
  "b": function() { return /* binding */ InfoTooltip; }
});

// EXTERNAL MODULE: ../node_modules/.pnpm/@swc+helpers@0.4.11/node_modules/@swc/helpers/src/_object_spread.mjs
var src_object_spread = __webpack_require__(31501);
// EXTERNAL MODULE: ../node_modules/.pnpm/@swc+helpers@0.4.11/node_modules/@swc/helpers/src/_object_spread_props.mjs
var src_object_spread_props = __webpack_require__(61079);
// EXTERNAL MODULE: ../node_modules/.pnpm/@swc+helpers@0.4.11/node_modules/@swc/helpers/src/_object_without_properties.mjs + 1 modules
var src_object_without_properties = __webpack_require__(89874);
// EXTERNAL MODULE: ../node_modules/.pnpm/react@18.2.0/node_modules/react/jsx-runtime.js
var jsx_runtime = __webpack_require__(35250);
// EXTERNAL MODULE: ../node_modules/.pnpm/@chakra-ui+hooks@2.0.11_react@18.2.0/node_modules/@chakra-ui/hooks/dist/index.esm.js
var index_esm = __webpack_require__(19267);
// EXTERNAL MODULE: ../node_modules/.pnpm/@chakra-ui+tooltip@2.2.0_@chakra-ui+system@2.2.12_framer-motion@7.4.0_react-dom@18.2.0_react@18.2.0/node_modules/@chakra-ui/tooltip/dist/index.esm.js
var dist_index_esm = __webpack_require__(67356);
// EXTERNAL MODULE: ../node_modules/.pnpm/@chakra-ui+layout@2.1.8_@chakra-ui+system@2.2.12_react@18.2.0/node_modules/@chakra-ui/layout/dist/index.esm.js
var layout_dist_index_esm = __webpack_require__(66697);
// EXTERNAL MODULE: ../node_modules/.pnpm/@chakra-ui+icon@3.0.11_@chakra-ui+system@2.2.12_react@18.2.0/node_modules/@chakra-ui/icon/dist/index.esm.js
var icon_dist_index_esm = __webpack_require__(93193);
// EXTERNAL MODULE: ../node_modules/.pnpm/@swc+helpers@0.4.11/node_modules/@swc/helpers/src/_sliced_to_array.mjs + 2 modules
var _sliced_to_array = __webpack_require__(42928);
// EXTERNAL MODULE: ./src/components/ModalOrDrawer/index.ts
var ModalOrDrawer = __webpack_require__(64881);
// EXTERNAL MODULE: ../node_modules/.pnpm/react@18.2.0/node_modules/react/index.js
var react = __webpack_require__(70079);
// EXTERNAL MODULE: ./src/components/MobileOrDesktop.tsx
var MobileOrDesktop = __webpack_require__(60303);
;// CONCATENATED MODULE: ./src/components/InfoDrawer/InfoDrawer.tsx









var InfoDrawer_InfoDrawer = function(_param) {
    var close = _param.close, isOpen = _param.isOpen, title = _param.title, children = _param.children, modalOrDrawerProps = (0,src_object_without_properties/* default */.Z)(_param, [
        "close",
        "isOpen",
        "title",
        "children"
    ]);
    var ref = (0,_sliced_to_array/* default */.Z)(react.Children.toArray(children), 2), content = ref[0], footer = ref[1];
    return /*#__PURE__*/ (0,jsx_runtime.jsxs)(ModalOrDrawer/* ModalOrDrawer */.NH, (0,src_object_spread_props/* default */.Z)((0,src_object_spread/* default */.Z)({
        placement: "bottom",
        size: "lg",
        scrollBehavior: "inside",
        isOpen: isOpen,
        onClose: function() {
            return close();
        }
    }, modalOrDrawerProps), {
        children: [
            /*#__PURE__*/ (0,jsx_runtime.jsx)(ModalOrDrawer/* ModalOrDrawerOverlay */.Dx, {}),
            /*#__PURE__*/ (0,jsx_runtime.jsxs)(ModalOrDrawer/* ModalOrDragDrawerContent */.Zt, {
                children: [
                    /*#__PURE__*/ (0,jsx_runtime.jsx)(MobileOrDesktop/* RenderInDesktop */.Po, {
                        children: /*#__PURE__*/ (0,jsx_runtime.jsx)(ModalOrDrawer/* ModalOrDrawerCloseButton */.M3, {})
                    }),
                    /*#__PURE__*/ (0,jsx_runtime.jsx)(ModalOrDrawer/* ModalOrDrawerHeader */.BB, {
                        children: title
                    }),
                    /*#__PURE__*/ (0,jsx_runtime.jsx)(ModalOrDrawer/* ModalOrDrawerBody */.M1, {
                        mb: "150px",
                        children: content
                    }),
                    footer && /*#__PURE__*/ (0,jsx_runtime.jsx)(ModalOrDrawer/* ModalOrDrawerFooter */.Un, {
                        children: footer
                    })
                ]
            })
        ]
    }));
};
var InfoDrawerContent = function(_param) {
    var children = _param.children, flexProps = _object_without_properties(_param, [
        "children"
    ]);
    return /*#__PURE__*/ _jsx(Flex, _object_spread_props(_object_spread({}, flexProps), {
        children: children
    }));
};
var InfoDrawerFooter = function(_param) {
    var children = _param.children, flexProps = _object_without_properties(_param, [
        "children"
    ]);
    return /*#__PURE__*/ _jsx(Flex, _object_spread_props(_object_spread({}, flexProps), {
        children: children
    }));
};
/* harmony default export */ var components_InfoDrawer_InfoDrawer = (InfoDrawer_InfoDrawer);

// EXTERNAL MODULE: ../node_modules/.pnpm/@swc+helpers@0.4.11/node_modules/@swc/helpers/src/_to_consumable_array.mjs + 2 modules
var _to_consumable_array = __webpack_require__(64705);
// EXTERNAL MODULE: ./src/utils/zustandMiddleware.ts + 45 modules
var zustandMiddleware = __webpack_require__(7306);
// EXTERNAL MODULE: ../node_modules/.pnpm/zustand@4.3.5_react@18.2.0/node_modules/zustand/esm/index.mjs + 1 modules
var esm = __webpack_require__(32848);
;// CONCATENATED MODULE: ./src/components/InfoDrawer/InfoDrawerWithIdentifier.tsx







var InfoDrawerWithIdentifier = function(_param) {
    var identifier = _param.identifier, props = _object_without_properties(_param, [
        "identifier"
    ]);
    var ref = useInfoDrawerWithIdentifier(), isInfoDrawerOpen = ref.isOpen, onCloseInfoDrawer = ref.close;
    return /*#__PURE__*/ _jsx(InfoDrawer, _object_spread({
        close: function() {
            return onCloseInfoDrawer(identifier);
        },
        isOpen: isInfoDrawerOpen(identifier)
    }, props));
};
var useInfoDrawerStore = (0,esm/* create */.Ue)((0,zustandMiddleware/* resetWhenRouterChange */.G)(function(set, get) {
    return {
        openDrawers: [],
        open: function(key) {
            return set(function() {
                return {
                    openDrawers: (0,_to_consumable_array/* default */.Z)(get().openDrawers).concat([
                        key
                    ])
                };
            });
        },
        close: function(key) {
            return set(function() {
                return {
                    openDrawers: get().openDrawers.filter(function(drawer) {
                        return key !== drawer;
                    })
                };
            });
        }
    };
}));
var useInfoDrawerWithIdentifier = function() {
    var ref = useInfoDrawerStore(), openDrawers = ref.openDrawers, open = ref.open, close = ref.close;
    var isOpen = function(key) {
        return openDrawers.includes(key);
    };
    return {
        isOpen: isOpen,
        open: open,
        close: close
    };
};
/* harmony default export */ var InfoDrawer_InfoDrawerWithIdentifier = ((/* unused pure expression or super */ null && (InfoDrawerWithIdentifier)));

;// CONCATENATED MODULE: ./src/components/InfoDrawer/index.tsx




// EXTERNAL MODULE: ../packages/icons/dist/esm/index.js + 53 modules
var dist_esm = __webpack_require__(99784);
;// CONCATENATED MODULE: ./src/components/InfoTooltip.tsx









var InfoTooltip = function(_param) {
    var title = _param.title, label = _param.label, tooltipProps = _param.tooltipProps, props = (0,src_object_without_properties/* default */.Z)(_param, [
        "title",
        "label",
        "tooltipProps"
    ]);
    var isDesktop = (0,MobileOrDesktop/* useIsDesktop */.Ce)();
    var ref = (0,index_esm/* useDisclosure */.qY)(), isInfoDrawerOpen = ref.isOpen, onCloseInfoDrawer = ref.onClose, onOpenInfoDrawer = ref.onOpen;
    return /*#__PURE__*/ (0,jsx_runtime.jsxs)(jsx_runtime.Fragment, {
        children: [
            /*#__PURE__*/ (0,jsx_runtime.jsx)(MobileOrDesktop/* RenderInMobile */.ub, {
                children: /*#__PURE__*/ (0,jsx_runtime.jsx)(components_InfoDrawer_InfoDrawer, {
                    close: onCloseInfoDrawer,
                    isOpen: isInfoDrawerOpen,
                    title: title,
                    children: label
                })
            }),
            /*#__PURE__*/ (0,jsx_runtime.jsx)(dist_index_esm/* Tooltip */.u, (0,src_object_spread_props/* default */.Z)((0,src_object_spread/* default */.Z)({
                p: 0,
                m: 0,
                color: "brand-black",
                bgColor: "bg.main",
                label: label
            }, tooltipProps), {
                children: /*#__PURE__*/ (0,jsx_runtime.jsx)(layout_dist_index_esm/* Flex */.kC, (0,src_object_spread_props/* default */.Z)((0,src_object_spread/* default */.Z)({
                    cursor: "pointer",
                    color: "pink.500"
                }, props), {
                    children: /*#__PURE__*/ (0,jsx_runtime.jsx)(icon_dist_index_esm/* Icon */.JO, {
                        as: dist_esm/* Info */.kI,
                        ml: 1,
                        w: "24px",
                        h: "24px",
                        onClick: function() {
                            if (!isDesktop) {
                                onOpenInfoDrawer();
                            }
                        }
                    })
                }))
            }))
        ]
    });
};


/***/ }),

/***/ 94343:
/***/ (function(__unused_webpack_module, __webpack_exports__, __webpack_require__) {


// EXPORTS
__webpack_require__.d(__webpack_exports__, {
  "M": function() { return /* reexport */ SEOTemplate; }
});

// EXTERNAL MODULE: ../node_modules/.pnpm/@swc+helpers@0.4.11/node_modules/@swc/helpers/src/_object_spread.mjs
var _object_spread = __webpack_require__(31501);
// EXTERNAL MODULE: ../node_modules/.pnpm/@swc+helpers@0.4.11/node_modules/@swc/helpers/src/_to_consumable_array.mjs + 2 modules
var _to_consumable_array = __webpack_require__(64705);
// EXTERNAL MODULE: ../node_modules/.pnpm/react@18.2.0/node_modules/react/jsx-runtime.js
var jsx_runtime = __webpack_require__(35250);
// EXTERNAL MODULE: ./src/config/externalLinks.ts
var externalLinks = __webpack_require__(1797);
// EXTERNAL MODULE: ./src/i18n/index.ts
var i18n = __webpack_require__(68866);
// EXTERNAL MODULE: ./src/overrides/next/router.ts
var router = __webpack_require__(95849);
// EXTERNAL MODULE: ../node_modules/.pnpm/lodash-es@4.17.21/node_modules/lodash-es/merge.js + 10 modules
var merge = __webpack_require__(66199);
// EXTERNAL MODULE: ../node_modules/.pnpm/next-seo@5.14.1_next@12.3.1_react-dom@18.2.0_react@18.2.0/node_modules/next-seo/lib/next-seo.module.js
var next_seo_module = __webpack_require__(75677);
;// CONCATENATED MODULE: ./src/components/SEO/SEOTemplate.tsx








var SITE_NAME = "veno.finance";
var AUTHOR = externalLinks/* EXTERNAL_LINK.twitter */.A.twitter;
var BASE_URL = "https://veno.finance";
var defaultSEOConfig = {
    noindex: false,
    nofollow: false,
    openGraph: {
        site_name: SITE_NAME,
        type: "website",
        article: {
            authors: [
                AUTHOR
            ]
        },
        images: [
            {
                url: "https://veno.finance/images/text-logo-large.png",
                width: 800,
                height: 196,
                alt: SITE_NAME
            }, 
        ]
    },
    twitter: {
        handle: AUTHOR,
        site: AUTHOR,
        cardType: "summary"
    }
};
var SEOTemplate = function(param) {
    var locale = param.locale, path = param.path, title = param.title, description = param.description, _moreConfig = param.moreConfig, moreConfig = _moreConfig === void 0 ? {} : _moreConfig, _textLimit = param.textLimit, textLimit = _textLimit === void 0 ? 300 : _textLimit;
    var asPath = (0,router/* useRouter */.tv)().asPath;
    // Remove the query in asPath
    path = path !== null && path !== void 0 ? path : asPath.split("?")[0];
    var url = "".concat(BASE_URL).concat(path);
    var languageAlternates = [
        {
            hrefLang: "x-default",
            href: url
        }, 
    ].concat((0,_to_consumable_array/* default */.Z)(i18n/* languages.map */.Mj.map(function(l) {
        return {
            hrefLang: l.lang,
            href: "".concat(BASE_URL, "/").concat(l.lang).concat(path)
        };
    })));
    description = description.length > textLimit ? description.slice(0, textLimit) + "..." : description;
    var customConfig = {
        title: title,
        titleTemplate: title,
        description: description,
        canonical: url,
        languageAlternates: languageAlternates,
        openGraph: {
            locale: locale,
            url: url,
            title: title,
            description: description
        }
    };
    var seoConfig = (0,merge/* default */.Z)({}, defaultSEOConfig, customConfig, moreConfig);
    return /*#__PURE__*/ (0,jsx_runtime.jsx)(next_seo_module/* NextSeo */.PB, (0,_object_spread/* default */.Z)({}, seoConfig));
};

;// CONCATENATED MODULE: ./src/components/SEO/index.ts



/***/ }),

/***/ 5533:
/***/ (function(__unused_webpack_module, __webpack_exports__, __webpack_require__) {

/* harmony import */ var _swc_helpers_src_object_spread_mjs__WEBPACK_IMPORTED_MODULE_5__ = __webpack_require__(31501);
/* harmony import */ var _swc_helpers_src_object_spread_props_mjs__WEBPACK_IMPORTED_MODULE_4__ = __webpack_require__(61079);
/* harmony import */ var _tanstack_react_query__WEBPACK_IMPORTED_MODULE_3__ = __webpack_require__(67496);
/* harmony import */ var _ui_providers_VenoSDKProvider__WEBPACK_IMPORTED_MODULE_0__ = __webpack_require__(29142);
/* harmony import */ var _ui_queries_sdk__WEBPACK_IMPORTED_MODULE_1__ = __webpack_require__(94693);
/* harmony import */ var _veno_app_wallet__WEBPACK_IMPORTED_MODULE_2__ = __webpack_require__(95142);






var useAccount = _veno_app_wallet__WEBPACK_IMPORTED_MODULE_2__/* .currentWallet.useAccount */ .AX.useAccount;
var useBoostMultLockedVno = function(options, address) {
    var sdk = (0,_ui_providers_VenoSDKProvider__WEBPACK_IMPORTED_MODULE_0__/* .useVenoSDK */ .ho)();
    var userAccount = useAccount();
    var account = address !== null && address !== void 0 ? address : userAccount;
    var query = (0,_ui_queries_sdk__WEBPACK_IMPORTED_MODULE_1__/* .getBoostMultiplierFromLockedVno */ .Js)(sdk, account !== null && account !== void 0 ? account : "");
    var ref = (0,_tanstack_react_query__WEBPACK_IMPORTED_MODULE_3__/* .useQuery */ .a)(query.queryKey, query.queryFn, (0,_swc_helpers_src_object_spread_props_mjs__WEBPACK_IMPORTED_MODULE_4__/* ["default"] */ .Z)((0,_swc_helpers_src_object_spread_mjs__WEBPACK_IMPORTED_MODULE_5__/* ["default"] */ .Z)({}, options), {
        enabled: !!account && ((options === null || options === void 0 ? void 0 : options.enabled) === undefined || (options === null || options === void 0 ? void 0 : options.enabled))
    })), boostMultiplier = ref.data, isLoading = ref.isLoading;
    return {
        isLoading: isLoading,
        boostMultiplier: boostMultiplier ? boostMultiplier.toNumber() / 10000 + 1 : undefined
    };
};
/* harmony default export */ __webpack_exports__["Z"] = (useBoostMultLockedVno);


/***/ }),

/***/ 94724:
/***/ (function(__unused_webpack_module, __webpack_exports__, __webpack_require__) {

/* harmony import */ var react__WEBPACK_IMPORTED_MODULE_0__ = __webpack_require__(70079);

function useDebounce(value, delay) {
    var ref = (0,react__WEBPACK_IMPORTED_MODULE_0__.useState)(value), debouncedValue = ref[0], setDebouncedValue = ref[1];
    (0,react__WEBPACK_IMPORTED_MODULE_0__.useEffect)(function() {
        if (typeof value === "string") setDebouncedValue("");
        var handler = setTimeout(function() {
            setDebouncedValue(value);
        }, delay);
        return function() {
            clearTimeout(handler);
        };
    }, [
        value,
        delay
    ]);
    return debouncedValue;
}
/* harmony default export */ __webpack_exports__["Z"] = (useDebounce);


/***/ }),

/***/ 31910:
/***/ (function(__unused_webpack_module, __webpack_exports__, __webpack_require__) {

/* unused harmony export getMaxMultiplier */
/* harmony import */ var _useBoostMultLockedVno__WEBPACK_IMPORTED_MODULE_0__ = __webpack_require__(5533);

var useFarmAprs = function() {
    var ref = (0,_useBoostMultLockedVno__WEBPACK_IMPORTED_MODULE_0__/* ["default"] */ .Z)(), boostMultiplier = ref.boostMultiplier, isLoading = ref.isLoading;
    return {
        isLoading: isLoading,
        boostMultiplier: boostMultiplier,
        isBoosted: !!boostMultiplier && boostMultiplier > 1
    };
};
var getMaxMultiplier = function() {
    // currently only VNO locking considered, no NFT stake
    // max here is 1.75
    return 1.75;
};
/* harmony default export */ __webpack_exports__["Z"] = (useFarmAprs);


/***/ }),

/***/ 55814:
/***/ (function(__unused_webpack_module, __webpack_exports__, __webpack_require__) {

/* harmony import */ var _tanstack_react_query__WEBPACK_IMPORTED_MODULE_8__ = __webpack_require__(67496);
/* harmony import */ var _ui_components_Features__WEBPACK_IMPORTED_MODULE_0__ = __webpack_require__(18232);
/* harmony import */ var _ui_providers_VenoSDKProvider__WEBPACK_IMPORTED_MODULE_1__ = __webpack_require__(29142);
/* harmony import */ var _ui_queries_partnerApys__WEBPACK_IMPORTED_MODULE_2__ = __webpack_require__(75379);
/* harmony import */ var _ui_queries_sdk__WEBPACK_IMPORTED_MODULE_3__ = __webpack_require__(94693);
/* harmony import */ var _veno_app_wallet__WEBPACK_IMPORTED_MODULE_4__ = __webpack_require__(95142);
/* harmony import */ var _useCoinMode__WEBPACK_IMPORTED_MODULE_5__ = __webpack_require__(93397);
/* harmony import */ var _useIsFeatureEnabled__WEBPACK_IMPORTED_MODULE_6__ = __webpack_require__(79623);
/* harmony import */ var _usePartnerStats__WEBPACK_IMPORTED_MODULE_7__ = __webpack_require__(82251);









var useAccount = _veno_app_wallet__WEBPACK_IMPORTED_MODULE_4__/* .currentWallet.useAccount */ .AX.useAccount;
var useGardenApy = function(type) {
    var includeProtocolApy = arguments.length > 1 && arguments[1] !== void 0 ? arguments[1] : false, _coinMode = arguments.length > 2 ? arguments[2] : void 0;
    var globalCoinMode = (0,_useCoinMode__WEBPACK_IMPORTED_MODULE_5__/* .useCoinMode */ .mc)();
    var coinMode = _coinMode !== null && _coinMode !== void 0 ? _coinMode : globalCoinMode;
    var sdk = (0,_ui_providers_VenoSDKProvider__WEBPACK_IMPORTED_MODULE_1__/* .useVenoSDK */ .ho)();
    var account = useAccount();
    var tectonicEnabled = (0,_useIsFeatureEnabled__WEBPACK_IMPORTED_MODULE_6__/* .isFeatureEnabled */ .cr)(_ui_components_Features__WEBPACK_IMPORTED_MODULE_0__/* .features.TectonicGarden */ .R.TectonicGarden);
    var ferroQuery = (0,_ui_queries_sdk__WEBPACK_IMPORTED_MODULE_3__/* .getGardenApr */ .fm)(coinMode, sdk, "FERRO", account);
    var ferroBoostMultiplierQuery = (0,_ui_queries_sdk__WEBPACK_IMPORTED_MODULE_3__/* .getBoostMultiplerForPool */ .Ld)(coinMode, sdk, account !== null && account !== void 0 ? account : "", "FERRO");
    var ref = (0,_tanstack_react_query__WEBPACK_IMPORTED_MODULE_8__/* .useQuery */ .a)(ferroQuery.queryKey, ferroQuery.queryFn, {
        enabled: type === undefined || type === "FERRO"
    }), ferroGardenOnlyApr = ref.data, ferroGardenOnlyAprLoading = ref.isLoading;
    var ref1 = (0,_tanstack_react_query__WEBPACK_IMPORTED_MODULE_8__/* .useQuery */ .a)(ferroBoostMultiplierQuery.queryKey, ferroBoostMultiplierQuery.queryFn, {
        enabled: type === undefined || type === "FERRO" && !!account
    }), ferroBoostMultiplier = ref1.data, ferroBoostMultiplierLoading = ref1.isLoading;
    var ferroApyQuery = (0,_ui_queries_partnerApys__WEBPACK_IMPORTED_MODULE_2__/* .getFerroApy */ .qe)(coinMode, true);
    var ref2 = (0,_tanstack_react_query__WEBPACK_IMPORTED_MODULE_8__/* .useQuery */ .a)(ferroApyQuery.queryKey, ferroApyQuery.queryFn, {
        enabled: (type === undefined || type === "FERRO") && includeProtocolApy
    }), ferroApy = ref2.data, ferroApyLoading = ref2.isLoading;
    var vvsQuery = (0,_ui_queries_sdk__WEBPACK_IMPORTED_MODULE_3__/* .getGardenApr */ .fm)(coinMode, sdk, "VVS", account);
    var vvsBoostMultiplierQuery = (0,_ui_queries_sdk__WEBPACK_IMPORTED_MODULE_3__/* .getBoostMultiplerForPool */ .Ld)(coinMode, sdk, account !== null && account !== void 0 ? account : "", "VVS");
    var ref3 = (0,_tanstack_react_query__WEBPACK_IMPORTED_MODULE_8__/* .useQuery */ .a)(vvsQuery.queryKey, vvsQuery.queryFn, {
        enabled: type === undefined || type === "VVS"
    }), vvsGardenOnlyApr = ref3.data, vvsGardenOnlyAprLoading = ref3.isLoading;
    var ref4 = (0,_tanstack_react_query__WEBPACK_IMPORTED_MODULE_8__/* .useQuery */ .a)(vvsBoostMultiplierQuery.queryKey, vvsBoostMultiplierQuery.queryFn, {
        enabled: type === undefined || type === "VVS" && !!account
    }), vvsBoostMultiplier = ref4.data, vvsBoostMultiplierLoading = ref4.isLoading;
    var vvsApyQuery = (0,_ui_queries_partnerApys__WEBPACK_IMPORTED_MODULE_2__/* .getVvsApy */ .Q7)(true);
    var ref5 = (0,_tanstack_react_query__WEBPACK_IMPORTED_MODULE_8__/* .useQuery */ .a)(vvsApyQuery.queryKey, vvsApyQuery.queryFn, {
        enabled: (type === undefined || type === "VVS") && includeProtocolApy
    }), vvsApy = ref5.data, vvsApyLoading = ref5.isLoading;
    var vvsCroQuery = (0,_ui_queries_sdk__WEBPACK_IMPORTED_MODULE_3__/* .getGardenApr */ .fm)(coinMode, sdk, "VVS_CRO", account);
    var vvsCroBoostMultiplierQuery = (0,_ui_queries_sdk__WEBPACK_IMPORTED_MODULE_3__/* .getBoostMultiplerForPool */ .Ld)(coinMode, sdk, account !== null && account !== void 0 ? account : "", "VVS_CRO");
    var ref6 = (0,_tanstack_react_query__WEBPACK_IMPORTED_MODULE_8__/* .useQuery */ .a)(vvsCroQuery.queryKey, vvsCroQuery.queryFn, {
        enabled: type === undefined || type === "VVS_CRO"
    }), vvsCroGardenOnlyApr = ref6.data, vvsCroGardenOnlyAprLoading = ref6.isLoading;
    var ref7 = (0,_tanstack_react_query__WEBPACK_IMPORTED_MODULE_8__/* .useQuery */ .a)(vvsCroBoostMultiplierQuery.queryKey, vvsCroBoostMultiplierQuery.queryFn, {
        enabled: type === undefined || type === "VVS_CRO" && !!account
    }), vvsCroBoostMultiplier = ref7.data, vvsCroBoostMultiplierLoading = ref7.isLoading;
    var vvsCroApyQuery = (0,_ui_queries_partnerApys__WEBPACK_IMPORTED_MODULE_2__/* .getVvsApy */ .Q7)(true);
    var ref8 = (0,_tanstack_react_query__WEBPACK_IMPORTED_MODULE_8__/* .useQuery */ .a)(vvsCroApyQuery.queryKey, vvsCroApyQuery.queryFn, {
        enabled: (type === undefined || type === "VVS_CRO") && includeProtocolApy
    }), vvsCroApy = ref8.data, vvsCroApyLoading = ref8.isLoading;
    ///
    var tectonicQuery = (0,_ui_queries_sdk__WEBPACK_IMPORTED_MODULE_3__/* .getGardenApr */ .fm)(coinMode, sdk, "TECTONIC", account);
    var tectonicBoostMultiplierQuery = (0,_ui_queries_sdk__WEBPACK_IMPORTED_MODULE_3__/* .getBoostMultiplerForPool */ .Ld)(coinMode, sdk, account !== null && account !== void 0 ? account : "", "TECTONIC");
    var ref9 = (0,_tanstack_react_query__WEBPACK_IMPORTED_MODULE_8__/* .useQuery */ .a)(tectonicQuery.queryKey, tectonicQuery.queryFn, {
        enabled: tectonicEnabled && (type === undefined || type === "TECTONIC")
    }), tectonicOnlyGardenApr = ref9.data, tectonicOnlyGardenAprLoading = ref9.isLoading;
    var ref10 = (0,_tanstack_react_query__WEBPACK_IMPORTED_MODULE_8__/* .useQuery */ .a)(tectonicBoostMultiplierQuery.queryKey, tectonicBoostMultiplierQuery.queryFn, {
        enabled: tectonicEnabled && !!account && (type === undefined || type === "TECTONIC")
    }), tectonicBoostMultiplier = ref10.data, tectonicBoostMultiplierLoading = ref10.isLoading;
    var ref11 = (0,_usePartnerStats__WEBPACK_IMPORTED_MODULE_7__/* .useTectonicApy */ .Gh)((type === undefined || type === "TECTONIC") && includeProtocolApy), tectonicApy = ref11.data;
    var ferroGardenAprLoading = ferroGardenOnlyAprLoading || ferroApyLoading && includeProtocolApy || ferroBoostMultiplierLoading;
    var vvsGardenAprLoading = vvsGardenOnlyAprLoading || vvsApyLoading && includeProtocolApy || vvsBoostMultiplierLoading;
    var vvsCroGardenAprLoading = vvsCroGardenOnlyAprLoading || vvsCroApyLoading && includeProtocolApy || vvsCroBoostMultiplierLoading;
    var tectonicGardenAprLoading = tectonicApy === undefined && includeProtocolApy || tectonicOnlyGardenAprLoading || tectonicBoostMultiplierLoading;
    var ferroGardenApy = getGardenApy(ferroGardenOnlyApr, ferroApy, ferroBoostMultiplier, includeProtocolApy);
    var vvsGardenApy = getGardenApy(vvsGardenOnlyApr, vvsApy, vvsBoostMultiplier, includeProtocolApy);
    var vvsCroGardenApy = getGardenApy(vvsCroGardenOnlyApr, vvsCroApy, vvsCroBoostMultiplier, includeProtocolApy);
    var tectonicGardenApy = getGardenApy(tectonicOnlyGardenApr, tectonicApy, tectonicBoostMultiplier, includeProtocolApy);
    return {
        ferroGardenApy: ferroGardenApy,
        ferroGardenAprLoading: ferroGardenAprLoading,
        vvsGardenApy: vvsGardenApy,
        vvsGardenAprLoading: vvsGardenAprLoading,
        tectonicGardenApy: tectonicGardenApy,
        tectonicGardenAprLoading: tectonicGardenAprLoading,
        vvsCroGardenApy: vvsCroGardenApy,
        vvsCroGardenAprLoading: vvsCroGardenAprLoading
    };
};
/* harmony default export */ __webpack_exports__["Z"] = (useGardenApy);
function getGardenApy(gardenOnlyApr, baseApy, boostMultiplier, includeProtocolApy) {
    var gardenApy = undefined;
    if (gardenOnlyApr === 0) {
        gardenApy = 0;
    } else if (gardenOnlyApr !== undefined && (baseApy !== undefined || !includeProtocolApy) && boostMultiplier !== undefined) {
        gardenApy = gardenOnlyApr * (!(0,_useIsFeatureEnabled__WEBPACK_IMPORTED_MODULE_6__/* .isFeatureEnabled */ .cr)(_ui_components_Features__WEBPACK_IMPORTED_MODULE_0__/* .features.NewGardenApr */ .R.NewGardenApr) ? boostMultiplier : 1) + (includeProtocolApy && baseApy ? baseApy : 0) / 100;
    }
    return gardenApy;
}


/***/ }),

/***/ 59023:
/***/ (function(__unused_webpack_module, __webpack_exports__, __webpack_require__) {

/* harmony export */ __webpack_require__.d(__webpack_exports__, {
/* harmony export */   "C": function() { return /* binding */ pushRouterWithoutRerender; },
/* harmony export */   "l": function() { return /* binding */ replaceRouterWithoutRerender; }
/* harmony export */ });
/* harmony import */ var _swc_helpers_src_object_spread_mjs__WEBPACK_IMPORTED_MODULE_3__ = __webpack_require__(31501);
/* harmony import */ var _swc_helpers_src_object_spread_props_mjs__WEBPACK_IMPORTED_MODULE_2__ = __webpack_require__(61079);
/* harmony import */ var _swc_helpers_src_sliced_to_array_mjs__WEBPACK_IMPORTED_MODULE_1__ = __webpack_require__(42928);
/* harmony import */ var _ui_i18n__WEBPACK_IMPORTED_MODULE_0__ = __webpack_require__(68866);




/**
 * @see https://github.com/vercel/next.js/discussions/18072#discussioncomment-109059
 */ var replaceRouterWithoutRerender = function(url) {
    var ref = (0,_swc_helpers_src_sliced_to_array_mjs__WEBPACK_IMPORTED_MODULE_1__/* ["default"] */ .Z)((0,_ui_i18n__WEBPACK_IMPORTED_MODULE_0__/* .getLangUrls */ .jd)(url), 2), newUrl = ref[0], newAsUrl = ref[1];
    window.history.replaceState((0,_swc_helpers_src_object_spread_props_mjs__WEBPACK_IMPORTED_MODULE_2__/* ["default"] */ .Z)((0,_swc_helpers_src_object_spread_mjs__WEBPACK_IMPORTED_MODULE_3__/* ["default"] */ .Z)({}, window.history.state), {
        as: newAsUrl,
        url: newUrl
    }), "", newAsUrl);
};
/**
 * @see https://github.com/vercel/next.js/discussions/18072#discussioncomment-109059
 */ var pushRouterWithoutRerender = function(url) {
    var ref = (0,_swc_helpers_src_sliced_to_array_mjs__WEBPACK_IMPORTED_MODULE_1__/* ["default"] */ .Z)((0,_ui_i18n__WEBPACK_IMPORTED_MODULE_0__/* .getLangUrls */ .jd)(url), 2), newUrl = ref[0], newAsUrl = ref[1];
    window.history.pushState((0,_swc_helpers_src_object_spread_props_mjs__WEBPACK_IMPORTED_MODULE_2__/* ["default"] */ .Z)((0,_swc_helpers_src_object_spread_mjs__WEBPACK_IMPORTED_MODULE_3__/* ["default"] */ .Z)({}, window.history.state), {
        as: newAsUrl,
        url: newUrl
    }), "", newAsUrl);
};


/***/ }),

/***/ 73068:
/***/ (function(__unused_webpack_module, __webpack_exports__, __webpack_require__) {

/* harmony export */ __webpack_require__.d(__webpack_exports__, {
/* harmony export */   "d": function() { return /* binding */ GardenBooster; }
/* harmony export */ });
/* harmony import */ var _swc_helpers_src_object_spread_mjs__WEBPACK_IMPORTED_MODULE_3__ = __webpack_require__(31501);
/* harmony import */ var _swc_helpers_src_object_spread_props_mjs__WEBPACK_IMPORTED_MODULE_2__ = __webpack_require__(61079);
/* harmony import */ var react_jsx_runtime__WEBPACK_IMPORTED_MODULE_0__ = __webpack_require__(35250);
/* harmony import */ var _chakra_ui_react__WEBPACK_IMPORTED_MODULE_1__ = __webpack_require__(66697);




var GardenBooster = function(props) {
    return /*#__PURE__*/ (0,react_jsx_runtime__WEBPACK_IMPORTED_MODULE_0__.jsx)(_chakra_ui_react__WEBPACK_IMPORTED_MODULE_1__/* .Box */ .xu, (0,_swc_helpers_src_object_spread_props_mjs__WEBPACK_IMPORTED_MODULE_2__/* ["default"] */ .Z)((0,_swc_helpers_src_object_spread_mjs__WEBPACK_IMPORTED_MODULE_3__/* ["default"] */ .Z)({
        p: "2px 4px 4px",
        textStyle: {
            base: "bodyBold",
            desktop: "bodySmallBold"
        },
        lineHeight: {
            base: "17px",
            desktop: "auto"
        },
        borderColor: "brand-green",
        rounded: "2px",
        borderWidth: "1px",
        color: "white",
        bg: "#4f775c",
        _dark: {
            borderColor: "#00FFCF",
            bg: "rgba(0, 255, 83, 0.5)"
        }
    }, props), {
        children: "Boosted"
    }));
};


/***/ }),

/***/ 85985:
/***/ (function(__unused_webpack_module, __webpack_exports__, __webpack_require__) {

/* harmony export */ __webpack_require__.d(__webpack_exports__, {
/* harmony export */   "q": function() { return /* binding */ useGardenModalStore; }
/* harmony export */ });
/* harmony import */ var _ui_config_paths__WEBPACK_IMPORTED_MODULE_0__ = __webpack_require__(71953);
/* harmony import */ var _ui_hooks_router__WEBPACK_IMPORTED_MODULE_1__ = __webpack_require__(81554);
/* harmony import */ var _ui_i18n__WEBPACK_IMPORTED_MODULE_2__ = __webpack_require__(68866);
/* harmony import */ var _ui_overrides_next_router__WEBPACK_IMPORTED_MODULE_3__ = __webpack_require__(95849);
/* harmony import */ var _ui_utils_garden__WEBPACK_IMPORTED_MODULE_4__ = __webpack_require__(98097);
/* harmony import */ var _ui_utils_urlHistory__WEBPACK_IMPORTED_MODULE_5__ = __webpack_require__(59023);
/* harmony import */ var _ui_utils_zustandMiddleware__WEBPACK_IMPORTED_MODULE_6__ = __webpack_require__(7306);
/* harmony import */ var zustand__WEBPACK_IMPORTED_MODULE_7__ = __webpack_require__(32848);








var useGardenModalStore = (0,zustand__WEBPACK_IMPORTED_MODULE_7__/* .create */ .Ue)((0,_ui_utils_zustandMiddleware__WEBPACK_IMPORTED_MODULE_6__/* .withReset */ .Y)(function(set, get) {
    return {
        isOpen: false,
        colorTheme: (0,_ui_utils_garden__WEBPACK_IMPORTED_MODULE_4__/* .getGardenColorThemeByCoinMode */ .Fs)("cro"),
        coinMode: "cro",
        close: function() {
            var _obj, ref;
            (ref = (_obj = useGardenModalStore.getState()).$$resetData) === null || ref === void 0 ? void 0 : ref.call(_obj);
            (0,_ui_utils_urlHistory__WEBPACK_IMPORTED_MODULE_5__/* .replaceRouterWithoutRerender */ .l)(_ui_config_paths__WEBPACK_IMPORTED_MODULE_0__/* .PATH_VNO */ .cU);
        },
        open: function(param) {
            var type = param.type, activeView = param.activeView, coinMode = param.coinMode;
            var nextActiveView = activeView !== null && activeView !== void 0 ? activeView : get().activeView;
            set({
                isOpen: true,
                type: type,
                activeView: nextActiveView,
                coinMode: coinMode,
                colorTheme: (0,_ui_utils_garden__WEBPACK_IMPORTED_MODULE_4__/* .getGardenColorThemeByCoinMode */ .Fs)(coinMode, type)
            });
            changeRouter({
                coinMode: coinMode,
                gardenType: type,
                gardenView: nextActiveView
            });
        },
        setActiveView: function(activeView) {
            set({
                activeView: activeView
            });
            changeRouter({
                coinMode: get().coinMode,
                gardenType: get().type,
                gardenView: activeView
            });
        },
        type: "TECTONIC",
        activeView: "PLANT"
    };
}));
var changeRouter = function(param) {
    var coinMode = param.coinMode, gardenType = param.gardenType, gardenView = param.gardenView;
    if ( true && !(0,_ui_hooks_router__WEBPACK_IMPORTED_MODULE_1__/* .isCategoryInSameView */ .HN)((0,_ui_hooks_router__WEBPACK_IMPORTED_MODULE_1__/* .getPathInfo */ .o$)((0,_ui_i18n__WEBPACK_IMPORTED_MODULE_2__/* .parsePathname */ .Q_)(window.location.pathname).pathname).category, "vno")) {
        _ui_overrides_next_router__WEBPACK_IMPORTED_MODULE_3__/* ["default"].push */ .ZP.push(_ui_config_paths__WEBPACK_IMPORTED_MODULE_0__/* .pathDict */ .o$[coinMode].garden[gardenType][gardenView]);
    } else {
        (0,_ui_utils_urlHistory__WEBPACK_IMPORTED_MODULE_5__/* .replaceRouterWithoutRerender */ .l)(_ui_config_paths__WEBPACK_IMPORTED_MODULE_0__/* .pathDict */ .o$[coinMode].garden[gardenType][gardenView]);
    }
};


/***/ })

}]);